import ClippyProvider from "./context/ClippyContext";
import AppProvider from "./context/AppContext";
import RightClickProvider from "./context/RightClickContext";
import NekoProvider from "./context/NekoContext";
import DesktopProvider from "./context/DesktopContext";
import AchievementProvider from "./context/AchievementContext";

import Desktop from "./components/Core/Desktop";
import TaskBar from "./components/Core/TaskBar";
import Achievements from "./components/Core/Achievements";

import AppModals from "./AppModals";

import "clippyts/src/clippy.css";

export default function App() {
  return (
    <AppProvider>
      <ClippyProvider>
        <AchievementProvider>
          <RightClickProvider>
            <NekoProvider>
              <TaskBar />

              <DesktopProvider>
                <Desktop />
              </DesktopProvider>

              <AppModals />
              <Achievements />
            </NekoProvider>
          </RightClickProvider>
        </AchievementProvider>
      </ClippyProvider>
    </AppProvider>
  );
}
